import * as Screenshot from "./../Screenshot";
import * as Logging from "./../Logging/Logging";
import * as Utils from "./Utils";

/**
 * Screenshot preview is control by screenshot check box. Populate preview if checkbox is checked 
 * @param screenshotCheckboxId The Id of screenshot checkbox 
 * @param screenshotPreviewId The Id of preview 
 */
export function ScreenshotPreviewByCheckbox(screenshotCheckboxId: string, screenshotPreviewId: string): void {
	const screenshotCheckBox = <HTMLInputElement> document.getElementById(screenshotCheckboxId);
	const screenshotCheckBoxSelected: boolean = screenshotCheckBox && screenshotCheckBox.checked;
	const preview = <HTMLImageElement> document.getElementById(screenshotPreviewId);

	if (screenshotCheckBoxSelected) {
		Utils.setElementVisibility(screenshotPreviewId, true);
		const startTime: number = performance.now();
		Screenshot.createScreenshot(document.body).then(
			(canvas: HTMLCanvasElement) => {
				const endTime: number = performance.now();
				Logging.getLogger().logEvent(Logging.EventIds.Shared.Screenshot.Render.Success.VALUE,
					Logging.LogLevel.Critical,
					{ TimeMilliseconds: endTime - startTime });

				preview.src = canvas.toDataURL();
			}
		).catch((error: any) => {
			const endTime: number = performance.now();
			Logging.getLogger().logEvent(Logging.EventIds.Shared.Screenshot.Render.Failed.VALUE,
				Logging.LogLevel.Error,
				{ ErrorMessage: error, TimeMilliseconds: endTime - startTime });
		});
	} else {
		Utils.setElementVisibility(screenshotPreviewId, false);
	}
}
